import { fileTypesConfig as commonConfig } from '@shared/ui-components/au-file-loader/au-file-loader.config';

export const fileTypesConfig = {
	image: commonConfig.image,
	iosImage: commonConfig.iosImage,
	video: commonConfig.video,
	msword: commonConfig.msword,
	odp: commonConfig.odp,
	exel: commonConfig.exel,
	csv: commonConfig.csv,
	txt: commonConfig.txt,
	ods: commonConfig.ods,
	pdf: commonConfig.pdf,
	presentation: commonConfig.presentation,
	cad: commonConfig.cad,
};
